import { SingleApiFormat } from '@/src/lib/http/jsonapi/deserializer';
import { StockQuantityResponse } from '@/src/lib/stock-quantity/types';
import { createClient } from '@/src/lib/http/client/client';

export async function getStockQuantity(skus: Array<string>) {
  const client = createClient();

  const response = await client.get(`/stock-quantity?skus=${skus.join(',')}`, { next: { revalidate: 10 } });

  return client.handleResponse<SingleApiFormat<StockQuantityResponse>>(response);
}
